import Typed from 'typed.js'

/**
 * Collection of strings to be shared across the component.
 * @enum {Object<string>}
 */
const CLASSES = {
  title: 'dr-intro__typing'
}

/**
 * Collection of numbers to be shared across the site.
 * @enum {Object<number>}
 */
const NUMBERS = {
  pauseDelay: 1500,
  speed: 50
}

/**
 * @module Intro
 */
class Intro {
  /**
   * @param {HTMLElement} element - The HTMLElement this module is constructed upon
   * @param {Object} options - ConditionerJS's merged options
   */
  constructor(element, options) {
    this.element_ = element
    this.options_ = options.options
    this.typeWriter_ = null
    this.init()
  }

  init() {
    this.instanceTyper()
  }

  instanceTyper() {
    this.options_ = this.options_.replace('&', '&amp;').split(',')
    this.typeWriter_ = new Typed(`.${CLASSES.title}`, {
      strings: this.options_,
      typeSpeed: NUMBERS.speed,
      backSpeed: NUMBERS.speed,
      backDelay: NUMBERS.pauseDelay,
      showCursor: true,
      cursorChar: '|',
      autoInsertCss: true,
      loop: true
    })
  }
}

export default Intro
